import React, { useState } from "react";
import { Link } from "react-router-dom";
import { auth } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [res, setRes] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      setRes(await auth.forgotPassword(email));
    } catch {
      setRes({ ok: true }); // never reveal existence
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-shell" data-testid="forgot-page">
      <form className="login-card" onSubmit={submit}>
        <div className="login-logo"><span className="logo-icon">⬡</span><span className="app-name">GovCo<span>.AI</span></span></div>
        <h2>Reset your password</h2>
        <p className="sub">Enter your email and we'll send a reset link.</p>

        {res ? (
          <>
            <div className="alert alert-info" style={{ marginTop: 8 }}>
              <span>✉️</span><span>If an account exists for {email}, a reset link is on its way.</span>
            </div>
            {res.reset_link && (
              <div className="alert alert-info" style={{ marginTop: 8, wordBreak: "break-all" }}>
                <span>🔗</span><span>Dev mode: <a href={res.reset_link}>{res.reset_link}</a></span>
              </div>
            )}
          </>
        ) : (
          <>
            <label htmlFor="email">Email</label>
            <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" />
            <button type="submit" className="btn btn-primary w-full" style={{ justifyContent: "center", marginTop: 16 }} disabled={loading} data-testid="forgot-submit">
              {loading ? <span className="spinner white" /> : "Send reset link"}
            </button>
          </>
        )}
        <div style={{ textAlign: "center", marginTop: 14, fontSize: 13 }}>
          <Link to="/login" style={{ color: "var(--primary)", fontWeight: 600 }}>Back to sign in</Link>
        </div>
      </form>
    </div>
  );
}
